export const ADMIN_ALL_LINK_REQUEST = "ADMIN_ALL_LINK_REQUEST";
export const ADMIN_ALL_LINK_SUCCESS = "ADMIN_ALL_LINK_SUCCESS";
export const ADMIN_ALL_LINK_FAIL = "ADMIN_ALL_LINK_FAIL";

export const SEARCH_LINK_DATA_REQUEST = "SEARCH_LINK_DATA_REQUEST";
export const SEARCH_LINK_DATA_SUCCESS = "SEARCH_LINK_DATA_SUCCESS";
export const SEARCH_LINK_DATA_FAIL = "SEARCH_LINK_DATA_FAIL";

export const SCROLL_DATA_REQUEST = "SCROLL_DATA_REQUEST";
export const SCROLL_DATA_SUCCESS = "SCROLL_DATA_SUCCESS";
export const SCROLL_DATA_FAIL = "SCROLL_DATA_FAIL";

export const SEARCH_LINK_CLEAR_ERRORS = "SEARCH_LINK_CLEAR_ERRORS";
